import { render, staticRenderFns } from "./Game_Version.vue?vue&type=template&id=f526c2da&scoped=true"
import script from "./Game_Version.vue?vue&type=script&lang=js"
export * from "./Game_Version.vue?vue&type=script&lang=js"
import style0 from "./Game_Version.vue?vue&type=style&index=0&id=f526c2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f526c2da",
  null
  
)

export default component.exports